import Invitation from './Invitation';

export const routes = [
	{
		path: '/invitation/completed',
		name: 'invitationCompleted',
		component: Invitation
	},
	{
		path: '/invitation/:id',
		name: 'invitation',
		component: Invitation
	}
];

export default routes;
